import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "text-message-action",
  "use": "text-message-action-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 38\" id=\"text-message-action\">\n    <path fill=\"#3F65FF\" d=\"M33.043 24.797a13.722 13.722 0 01-12.27 7.587 13.53 13.53 0 01-6.134-1.453L7.05 32.384l1.453-7.587a13.53 13.53 0 01-1.453-6.135A13.722 13.722 0 0114.64 6.393a13.53 13.53 0 016.134-1.453h.808a13.69 13.69 0 0112.915 12.915v.807a13.53 13.53 0 01-1.453 6.135z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol